import { render } from "./App.vue?vue&type=template&id=e8f54ae2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e8f54ae2&lang=scss"

import exportComponent from "/data/apps/fbe-location-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__